export default {
    // Bump when the cookie/consent-politik ændres → ældre gemte valg invalideres,
    // så returnerende besøgende re-promptes ÉN gang. v2: banneret blev tidligere
    // aldrig vist (CookieConsent var ikke mountet i noget layout), så v1-valg
    // skal genindhentes nu hvor banneret faktisk virker.
    CONSENT_VERSION: 2,

    getCookiePreferences() {
        if (typeof document === 'undefined') return null;
        try {
            const cookieValue = document.cookie
                .split('; ')
                .find(row => row.startsWith('cookiePreferences='))
                ?.split('=')[1];

            if (cookieValue) {
                return JSON.parse(decodeURIComponent(cookieValue));
            }
        } catch (e) {
            console.error('Error parsing cookie preferences:', e);
        }
        return null;
    },

    saveCookiePreferences(preferences) {
        if (typeof document === 'undefined') return;
        // Set expiry to 6 months
        const expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 6);

        // Necessary cookies are always enabled
        preferences.necessary = true;

        // Stamp med nuværende consent-version, så fremtidige politik-ændringer
        // kan re-prompte ved at bumpe CONSENT_VERSION.
        preferences.version = this.CONSENT_VERSION;

        // Set cookie with preferences
        const cookieValue = encodeURIComponent(JSON.stringify(preferences));
        document.cookie = `cookiePreferences=${cookieValue};expires=${expiryDate.toUTCString()};path=/;SameSite=Lax;Secure`;

        // Update consent state based on preferences
        this.updateConsentState(preferences);

        // Load GTM only when marketing is consented
        if (preferences.marketing) {
            this.loadGoogleTagManager();
        }
    },

    hasConsent() {
        const prefs = this.getCookiePreferences();
        // Et ældre/versionsløst gemt valg behandles som "ingen stillingtagen",
        // så banneret vises igen efter et CONSENT_VERSION-bump.
        return prefs !== null && prefs.version === this.CONSENT_VERSION;
    },

    consentTo(type) {
        const prefs = this.getCookiePreferences();
        return prefs && prefs[type] === true;
    },

    updateConsentState(preferences) {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

        window.gtag('consent', 'update', {
            'analytics_storage': preferences.analytics ? 'granted' : 'denied',
            'ad_storage': preferences.marketing ? 'granted' : 'denied',
            'ad_user_data': preferences.marketing ? 'granted' : 'denied',
            'ad_personalization': preferences.marketing ? 'granted' : 'denied',
        });
    },

    loadConsentedScripts(preferences) {
        if (typeof window === 'undefined') return;
        if (!preferences) {
            preferences = this.getCookiePreferences();
        }

        if (!preferences) return;

        // Update GA4 consent state (GA4 is already loaded via app.blade.php)
        this.updateConsentState(preferences);

        if (preferences.marketing) {
            this.loadGoogleTagManager();
        }
    },

    loadGoogleTagManager() {
        if (typeof window === 'undefined') return;
        // Avoid loading twice
        if (document.querySelector('script[src*="gtm.js?id=GTM-PRCPPDMM"]')) return;

        (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-PRCPPDMM');

        // Add noscript iframe if it doesn't exist
        if (!document.querySelector('noscript iframe[src*="GTM-PRCPPDMM"]')) {
            const noscript = document.createElement('noscript');
            const iframe = document.createElement('iframe');
            iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-PRCPPDMM";
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.display = "none";
            iframe.style.visibility = "hidden";
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        }
    }
}
